import { fetchPage, postPage, deletePage } from "@/services/config";
import type {
  AddDomainRequest,
  DeleteDomainResponse,
  DomainResponse,
  RootSettingsRequest,
  RootSettingsResponse,
  SmtpSettingRequest,
  SmtpSettingResponse
} from "@/types";

const serviceBase = "tenant-branding";

// Root Settings endpoints
export function getRootSettings(tenantId: number): Promise<RootSettingsResponse> {
  return fetchPage<RootSettingsResponse>(serviceBase, `/${tenantId}/settings`);
}

export function createRootSettings(tenantId: number, payload: RootSettingsRequest): Promise<RootSettingsResponse> {
  return postPage<RootSettingsResponse, RootSettingsRequest>(serviceBase, `/${tenantId}/settings`, payload);
}

export function updateRootSettings(tenantId: number, payload: RootSettingsRequest): Promise<RootSettingsResponse> {
  return postPage<RootSettingsResponse, RootSettingsRequest>(serviceBase, `/${tenantId}/settings`, payload, {}, "PATCH");
}

export function testEmailSettings(tenantId: number): Promise<void> {
  return postPage<void>(serviceBase, `/${tenantId}/settings/test`, {});
}

// SMTP Settings endpoints
export function getSmtpSetting(tenantId: number): Promise<SmtpSettingResponse> {
  return fetchPage<SmtpSettingResponse>(serviceBase, `/${tenantId}/smtp_setting`);
}

export function createSmtpSetting(tenantId: number, payload: SmtpSettingRequest): Promise<SmtpSettingResponse> {
  return postPage<SmtpSettingResponse, SmtpSettingRequest>(serviceBase, `/${tenantId}/smtp_setting`, payload);
}

export function updateSmtpSetting(tenantId: number, payload: SmtpSettingRequest): Promise<SmtpSettingResponse> {
  return postPage<SmtpSettingResponse, SmtpSettingRequest>(serviceBase, `/${tenantId}/smtp_setting`, payload, {}, "PATCH");
}

// DKIM Domain endpoints
export function listDomains(tenantId: number): Promise<DomainResponse[]> {
  return fetchPage<DomainResponse[]>(serviceBase, `/${tenantId}/direct_email_setting/domains`);
}

export function addDomain(tenantId: number, payload: AddDomainRequest): Promise<DomainResponse> {
  return postPage<DomainResponse, AddDomainRequest>(serviceBase, `/${tenantId}/direct_email_setting/domain`, payload);
}

export function verifyDomain(tenantId: number, domainId: string): Promise<DomainResponse> {
  return postPage<DomainResponse>(serviceBase, `/${tenantId}/direct_email_setting/domain/${domainId}`, {});
}

export function deleteDomain(tenantId: number, domainId: string): Promise<DeleteDomainResponse> {
  return deletePage<DeleteDomainResponse>(serviceBase, `/${tenantId}/direct_email_setting/domain/${domainId}`);
}
